import {useSalesTargetsQuery} from '@/hooks/useSalesTargetsQuery';
import {useSalesTargetsActions} from '@/hooks/useSalesTargetsActions';

/**
 * Hook for managing sales targets data and actions.
 * Composes useSalesTargetsQuery, useSalesTargetsActions, and useSalesTargetsForm.
 * @param {boolean} enableQuery - Whether to enable the sales targets list query.
 *                                Set to false for pages that only need the utility functions (handleDraft, handlePublish, etc.)
 *                                and don't need the list data to avoid unnecessary API calls.
 */
export const useSalesTargets = (enableQuery = true) => {
  const query = useSalesTargetsQuery(enableQuery);
  const actions = useSalesTargetsActions({
    searchArr: query.searchArr,
    queryParams: query.queryParams
  });

  return {
    ...query,
    ...actions
  };
};
